/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $RedisQueueLength = {
    properties: {
        long: {
            type: 'number',
            isRequired: true,
        },
        short: {
            type: 'number',
            isRequired: true,
        },
        match_metrics: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
